/* global dataLayer, gtmEnabled, APP_ENV*/

/**
 * @typedef {object} LeadCreatedEventDetails
 * @property {boolean} isJobApp
 * @property {boolean} hasMatchingClients
 * @property {boolean} qualifiedForJob
 * @property {int|null} leadId
 * @property {string} license
 */
export default class TagManager {
    /**
     * Pushes a lead created event to the dataLayer.
     * @param {LeadCreatedEventDetails} details
     */
    static leadCreated(details = {}) {
        TagManager.pushEvent('lead_created', details);
    }

    static advertiseRequestSubmitted(details = {}) {
        TagManager.pushEvent('advertise_request_submitted', details);
    }

    static advertiseRequestSubmittedLinkedin(details = {}) {
        TagManager.pushEvent('linkedin_advertise_conversion', details);
    }

    /**
     * @param {ConversionData} conversionData
     */
    static setConversionData(conversionData = {}) {
        if (conversionData.sha256_email_address != undefined) {
            __gtm_conversion_sha256_email_address = conversionData.sha256_email_address;
        }
        if (conversionData.sha256_phone_number != undefined) {
            __gtm_conversion_sha256_phone_number = conversionData.sha256_phone_number;
        }
        if (conversionData.address_sha256_first_name != undefined) {
            __gtm_conversion_address_sha256_first_name = conversionData.address_sha256_first_name;
        }
        if (conversionData.address_sha256_last_name != undefined) {
            __gtm_conversion_address_sha256_last_name = conversionData.address_sha256_last_name;
        }
        if (conversionData.address_street != undefined) {
            __gtm_conversion_address_street = conversionData.address_street;
        }
        if (conversionData.address_city != undefined) {
            __gtm_conversion_address_city = conversionData.address_city;
        }
        if (conversionData.address_region != undefined) {
            __gtm_conversion_address_region = conversionData.address_region;
        }
        if (conversionData.address_postal_code != undefined) {
            __gtm_conversion_address_postal_code = conversionData.address_postal_code;
        }
        if (conversionData.address_country != undefined) {
            __gtm_conversion_address_country = conversionData.address_country;
        }
    }

    /**
     * Push custom events to the dataLayer for Google Tag Manager to catch
     * @param {string} eventName
     * @param {object} data
     */
    static pushEvent(eventName, data= {}) {
        TagManager.dataLayerExists();

        if (!gtmEnabled) {
            if (APP_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.log(`Google Tag Manager is disabled. Event ${eventName} would have fired with the following.`);
                // eslint-disable-next-line no-console
                console.table(data);
            }

            return;
        }

        dataLayer?.push({
            event: eventName,
            ...data,
        });
    }

    static dataLayerExists() {
        window.dataLayer = window.dataLayer || [];
    }
}
